import React from 'react';
import { Wrapper, Tone } from './styles';

export interface BadgeProps {
  tone?: Tone;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', children }) => (
  <Wrapper tone={tone}>{children}</Wrapper>
);

export default Badge;
